import { render, staticRenderFns } from "./ProjectManagerCurrentProject.vue?vue&type=template&id=d23f16c6"
import script from "./ProjectManagerCurrentProject.vue?vue&type=script&lang=js"
export * from "./ProjectManagerCurrentProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports